<template>
  <a
    :href="buttonUrl"
    :target="targetValue"
    class="buttonLink"
    :class="[buttonColor, buttonSize, { isPc: !isSp, maxWidthNone: maxWidthNone }]"
    @click="clicked($event)"
  >
    <span class="buttonLinkText">{{ buttonText }}</span>
  </a>
</template>

<script>
export const BUTTON_COLOR_LIST = {
  DEFAULT: 'colorDefault',
  SECONDARY: 'colorSecondry',
  PRIMARY: 'colorPrimary',
  PRIMARY_BORDER: 'colorPrimaryBorder',
  CTA: 'colorCta',
  SAPURI_WHITE: 'colorSapuriWhite',
};

export default {
  name: 'ButtonLink',
  props: {
    buttonUrl: {
      type: String,
      required: true,
    },
    targetValue: {
      required: false,
      default: '_self',
      validator(value) {
        return ['_self', '_blank', '_parent', '_top'].indexOf(value) !== -1;
      },
    },
    buttonText: {
      type: String,
      required: true,
    },
    buttonColor: {
      default: 'colorDefault',
      validator(value) {
        return Object.values(BUTTON_COLOR_LIST).indexOf(value) !== -1;
      },
    },
    buttonSize: {
      default: 'sizeMedium',
      validator(value) {
        return ['sizeXLarge', 'sizeLarge', 'sizeMedium', 'sizeSmall'].indexOf(value) !== -1;
      },
    },
    isSpFlg: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    maxWidthNone: {
      type: Boolean,
      required: false,
      default: undefined,
    },
  },
  computed: {
    isSp() {
      if (typeof this.isSpFlg === 'boolean') return this.isSpFlg;
      return this.$isSp;
    },
  },
  methods: {
    clicked(event) {
      this.$emit('button-clicked', event);
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'css/contents/common/global';

.buttonLink {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  border-radius: 4px;
  box-sizing: border-box;
  text-decoration: none;
  cursor: pointer;

  &.isPc {
    margin: 0 auto;
    max-width: 360px;

    &.maxWidthNone {
      max-width: none;
    }
  }
}

.buttonLinkText {
  line-height: 1;
  font-weight: bold;
}

.sizeXLarge {
  height: 60px;
  font-size: 20px;
}

.sizeLarge {
  height: 48px;
  font-size: 18px;
}

.sizeMedium {
  height: 40px;
  font-size: 16px;
}

.sizeSmall {
  height: 32px;
  font-size: 14px;
}

@mixin hoverView {
  &:hover {
    opacity: 0.7;
  }
}

.colorDefault {
  border: solid 1px $color-action-spot-action-light;
  background: $color-background-primary-third-light;

  & > span {
    color: $color-action-spot-action-light;
  }

  @include hoverView;
}

.colorSecondry {
  border: solid 1px $color-action-secondry;
  background: 0;

  & > span {
    color: $color-action-secondry;
  }

  @include hoverView;
}

.colorPrimary {
  background: $color-action-primary;

  & > span {
    color: #fff;
  }

  @include hoverView;
}

.colorPrimaryBorder {
  border: solid 1px $color-action-primary;

  & > span {
    color: $color-action-primary;
  }

  @include hoverView;
}

.colorCta {
  background: $color-action-cta;

  & > span {
    color: #fff;
  }

  &:hover {
    background-color: #ffab4d;
  }
}

.colorSapuriWhite {
  border: $border-sapuri-white-light;

  & > span {
    color: $color-text-secondry;
  }

  @include hoverView;
}
</style>
